<template>
  <div class="head" ref="goTop">
    <div class="app-nav">
      <div class="responsive">
        <a href="javascript:void(0);" class="app-logo"><img src="../assets/Amei.png" alt="logo image"></a>
        <div class="app-right">
          <ul class="right-list clearfix" :class="{'is-login': user.isLogin}">
            <li>
              <router-link to="/">首页</router-link>
            </li>
            <li v-for="(item, index) in tempObj" :key="index" v-if="authorizations.indexOf(item.key) > -1">
              <router-link :to="item.path">{{ item.title }}</router-link>
            </li>
            <li>
              <router-link to="/about">关于</router-link>
            </li>
            <div class="user right">
              <img alt="" :src="user.imageUrl || defaultImg" width="30px" height="30px">
            </div>
            <div class="user-box" :class="{'no-pointer': noPointer}">
              <div>
                <i class="el-icon-caret-top"></i>
                <div v-if="!user.isLogin">
                  <el-form :model="formData" status-icon :rules="rules" ref="formData" label-width="0" class="center">
                    <el-form-item prop="username">
                      <el-input v-model.number="formData.username" placeholder="请输入用户名" @keyup.enter.native="submitForm('formData')"></el-input>
                    </el-form-item>
                    <el-form-item prop="password">
                      <el-input type="password" v-model="formData.password" placeholder="请输入密码" auto-complete="off" @keyup.enter.native="submitForm('formData')"></el-input>
                    </el-form-item>
                    <div class="nowrap">
                      <el-button type="primary" size="small" @click="showRegister">还没账号? 去注册</el-button>
                      <el-button type="primary" size="small" @click="submitForm('formData')">登录</el-button>
                    </div>
                  </el-form>
                </div>
                <div v-else class="user-login">
                  <div class="nowrap">
                    bigboss账号: {{user.userName}}
                    <span @click="logout" class="gray pointer m-l-10">退出</span>
                  </div>
                  <div class="m-t-10 clearfix">
                    <span @click="editUser('info')" class="gray pointer left">修改个人信息</span>
                    <span @click="editUser('pass')" class="gray pointer right">修改密码</span>
                  </div>
                  <div>
                    <ul class="right-list clearfix menu-for-mobile m-t-20">
                      <li>
                        <router-link to="/">首页</router-link>
                      </li>
                      <li v-for="(item, index) in tempObj" :key="index" v-if="authorizations.indexOf(item.key) > -1">
                        <router-link :to="item.path">{{ item.title }}</router-link>
                      </li>
                      <li>
                        <router-link to="/about">关于</router-link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="user-box register" v-if="registerBox">
              <div>
                <i class="el-icon-caret-top"></i>
                <div>
                  <el-form :model="registerFormData" status-icon :rules="rules2" ref="registerFormData" label-width="0" class="center">
                    <el-form-item class="m-b-0" v-if="registerBox != 'pass'">
                        <el-upload class="avatar-uploader" drag
                                 action="https://leo2vip.top/bigboss-feign/uploadWeb/uploadPic/test"
                                 :show-file-list="false" :with-credentials="true"
                                 :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
                        <img v-if="registerFormData.imageUrl" :src="registerFormData.imageUrl" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      </el-upload>
                    </el-form-item>
                    <el-form-item prop="sex" class="m-b-10" v-if="registerBox != 'pass'">
                      <el-radio-group v-model="registerFormData.sex">
                        <el-radio :label="1">男</el-radio>
                        <el-radio :label="2">女</el-radio>
                      </el-radio-group>
                    </el-form-item>
                    <el-form-item prop="realName" v-if="registerBox != 'pass'">
                      <el-input v-model="registerFormData.realName" placeholder="请输入真实姓名" auto-complete="off" @keyup.enter.native="submitForm('registerFormData')"></el-input>
                    </el-form-item>
                    <el-form-item prop="email" v-if="registerBox != 'pass'">
                      <el-input v-model="registerFormData.email" placeholder="请输入电子邮箱" auto-complete="off" @keyup.enter.native="submitForm('registerFormData')"></el-input>
                    </el-form-item>
                    <el-form-item prop="userName" v-if="registerBox == 'register'">
                      <el-input v-model.number="registerFormData.userName" placeholder="请输入用户名" :autofocus="true" @keyup.enter.native="submitForm('registerFormData')"></el-input>
                    </el-form-item>
                    <el-form-item prop="passWord" v-if="registerBox != 'info'">
                      <el-input type="password" v-model="registerFormData.passWord" placeholder="请输入密码" auto-complete="off" @keyup.enter.native="submitForm('registerFormData')"></el-input>
                    </el-form-item>
                    <el-form-item prop="checkPass" v-if="registerBox != 'info'">
                      <el-input type="password" v-model="registerFormData.checkPass" placeholder="请再次输入密码" auto-complete="off" @keyup.enter.native="submitForm('registerFormData')"></el-input>
                    </el-form-item>
                    <el-button type="primary" plain size="small" @click="cancelregister">关闭</el-button>
                    <el-button type="primary" size="small" @click="submitForm('registerFormData')" class="m-l-16">{{ (registerBox == 'register') ? '注册': '修改' }}</el-button>
                  </el-form>
                </div>
              </div>
            </div>
          </ul>
          <a href="javascript:void(0);" class="right-menu" >
            <span class="right-menu-icon"></span>
            <span class="right-menu-icon"></span>
            <span class="right-menu-icon"></span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data: function() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.registerFormData.passWord) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      defaultImg: require('@/assets/default.png'),
      authorizations: [],
      tempObj: [{title: 'List', key: 'list', path: '/list'},
                {title: '履历', key: 'entry', path: '/entry'},
                {title: 'show', key: 'show', path: '/show'}],
      registerBox: false, //注册模态框 register | info | pass
      noPointer: false,
      user: {
        isLogin: false,
        imageUrl: '',
        userId: '',
        userName: ''
      },
      formData: {
        username: '',
        password: '',
        code: '',
        rememberMe: true
      },
      rules: {
        username: [{ required: true, trigger: 'blur', message: '用户名不能为空!' }],
        password: [{ required: true, trigger: 'blur', message: '密码不能为空!' }]
      },
      registerFormData: {
        realName: '',
        email: '',
        sex: 1, //1男 2女
        userName: '',
        passWord: '',
        checkPass: '',
        imageUrl: undefined,
        status: 0 //0正常，1删除
      },
      rules2: {
        realName: [{ required: true, trigger: 'blur', message: '请输入真实姓名!' }],
        email: [{ required: true, trigger: 'blur', message: '请输入电子邮箱!' },
                { pattern: /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,})+$/, trigger: 'blur', message: '请输入正确的电子邮箱!' }],
        userName: [{ required: true, trigger: 'blur', message: '用户名不能为空!' }],
        passWord: [{ required: true, trigger: 'blur', message: '请输入密码!' }],
        checkPass: [{ validator: validatePass, trigger: 'blur' }]
      }
    };
  },
  mounted() {
    this.user = this.$getStorage('user') || {};
    this.version = this.$getStorage('version');
    if (this.version && (this.$VERSION != this.version)) {
      this.clearData();
    } else {
      this.authorizations = this.$getStorage('authorizations') || [];
    }
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (formName == 'registerFormData') {
            switch (this.registerBox) {
              case 'register':
                this.toRegister();
                break;
              case 'info':
                this.updateUser();
                break;
              case 'pass':
                this.updatePass();
                break;
            }
          } else {
            this.toLogin();
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    toLogin() {
      var that = this;
      that.$post('login', that.formData)
        .then((res) => {

          //登录后隐藏登录框
          that.noPointer = true;
          setTimeout(function(){
            that.noPointer = false;
          }, 200);

          that.$message.success('登录成功!');
          that.$emit('give-user', res.data.userName);

          that.$clearStorage();
          that.setUser(res.data);
          that.getUserRoleAuth(res.data.id);
        }).catch((e) => {});
    },
    setUser(data) {
      this.user = {
        isLogin: true,
        userId: data.id || data.userId,
        userName: data.userName,
        imageUrl: data.imageUrl,
        realName: data.realName,
        email: data.email,
        sex: data.sex
      };
      this.$setStorage('user', this.user);
      this.$setStorage('version', this.$VERSION);
    },
    getUserRoleAuth(userId) {
      this.$get('getUserRoleAuth', {urlPlaceholder: {userId: userId}})
        .then((res) => {
          let authorizations = [];
          res.data.bigbossAuthorizations.forEach(ele => {
            authorizations.push(ele.url);
          });
          this.authorizations = authorizations;
          this.$setStorage('authorizations', authorizations);
        }).catch((e) => {});
    },
    logout() {
      this.$get('logout')
        .then((res) => {
          this.$message.success('退出登录成功!');
          this.clearData();
        }).catch((e) => {});
    },
    clearData() {
      this.$clearStorage();
      this.user = {};
      this.authorizations = [];
      this.$emit('give-user', '');
      this.$router.replace({ name: 'default' }).catch((e) => {});
    },
    showRegister(isCancel) {
      this.$refs['formData'].clearValidate();
      this.registerFormData = {
        realName: '',
        email: '',
        userName: '',
        passWord: '',
        checkPass: '',
        sex: 1,
        imageUrl: undefined,
        status: 0 //0正常，1删除
      };
      this.registerBox = 'register';
    },
    cancelregister() {
      this.$refs['registerFormData'].clearValidate();
      this.registerBox = false;
    },
    toRegister() {
      var that = this;
      var params = {
        realName: that.registerFormData.realName,
        email: that.registerFormData.email,
        userName: that.registerFormData.userName,
        passWord: that.registerFormData.passWord,
        imageUrl: that.registerFormData.imageUrl,
        sex: that.registerFormData.sex,
        status: 0 //0正常，1删除
      };
      that.$post('addUser', params)
        .then((res) => {
          that.clearData();
          that.$message.success('注册成功! 立即登录~');
          this.registerBox = false;
        }).catch((e) => {});
    },
    editUser(type) {
      this.registerBox = type;
      const user = this.user;
      this.registerFormData = {
        realName: user.realName,
        email: user.email,
        userName: user.userName, //仅为验证
        passWord: type == 'pass' ? '' : '*',
        checkPass: type == 'pass' ? '' : '*',
        sex: user.sex,
        imageUrl: user.imageUrl,
        userId: user.userId,
        status: 0 //0正常，1删除
      };
    },
    updateUser() {
      var that = this;
      var params = {
        userName: that.registerFormData.userName, //不能改，但是传参
        realName: that.registerFormData.realName,
        email: that.registerFormData.email,
        sex: that.registerFormData.sex,
        imageUrl: that.registerFormData.imageUrl,
        id: that.registerFormData.userId,
        isUpdatePassword: 0 //0不修改密码，1修改密码
      };

      that.$put('updateUser', params)
        .then((res) => {
          that.$message.success('个人信息修改成功!');
          that.registerBox = false;
          that.setUser(that.registerFormData);
        }).catch((e) => {});
    },
    updatePass() {
      var that = this;
      var params = {
        userName: that.registerFormData.userName, //不能改，但是传参
        passWord: that.registerFormData.passWord,
        id: that.registerFormData.userId,
        isUpdatePassword: 1
      };

      that.$put('updateUser', params)
        .then((res) => {
          that.$message.success('密码修改成功!');
          that.registerBox = false;
        }).catch((e) => {});
    },
    //文件上传成功时的钩子
    handleAvatarSuccess(res, file) {
      // this.baseInfo.imageUrl = URL.createObjectURL(file.raw);
      this.registerFormData.imageUrl = res.msg;
    },

    //上传文件之前的钩子，参数为上传的文件，若返回 false 或者返回 Promise 且被 reject，则停止上传。
    beforeAvatarUpload(file) {
      // const isJPG = file.type === 'image/jpeg';
      const isJPG = true;
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    }
  }
};
</script>
